import styled from 'styled-components';
import { Popup, Overlay } from '@fluentui/react';
import { colorPallet } from 'src/styles/theme/colors';
import { isMobile } from 'react-device-detect';

export const PopupStyled = styled(Popup)`
  background: ${(props) => props.theme.popupOpacity};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10;
`;

export const OverlayStyled = styled(isMobile ? styled.div`` : Overlay)``;

export const StyledLayer = styled.div`
  i:hover {
    color: red;
  }

  [class*='ms-slideDownIn'] [class*='root-'] {
    color: ${colorPallet.white};
  }
`;

export const RequestContainer = styled.div`
  background: ${(props) => props.theme.popupMainBackground};
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 2px;

  @media (max-width: 710px) {
    width: 100%;
    height: 100svh;
    overflow-y: scroll;
  }
`;
